{
  "eyebrow": "Facturation & paiement",
  "title": "Presque terminé.",
  "sub": "Continuez vers notre paiement sécurisé pour démarrer votre essai de 30 jours. Aucun débit aujourd'hui.",
  "summary": {
    "plan": "Formule",
    "cycle": "Cycle de facturation",
    "users": "Utilisateurs",
    "vtt": "Vehicle Track & Trace",
    "vehicles": "Véhicules",
    "total": "Total estimé / mois",
    "vttOn": "Inclus"
  },
  "secureNote": "Paiement sécurisé par Stripe · 30 jours d'essai gratuit · Annulez à tout moment",
  "continue": "Continuer vers Stripe",
  "submitting": "Ouverture de Stripe…",
  "canceled": {
    "title": "Paiement annulé",
    "sub": "Aucun débit n'a été effectué. Réessayez ou contactez-nous si besoin d'aide.",
    "retry": "Réessayer"
  },
  "promo": {
    "toggle": "Vous avez un code promo ?",
    "placeholder": "Code promo",
    "apply": "Appliquer",
    "chip": "{{percent}} % de réduction",
    "remove": "Retirer le code promo",
    "errorGeneric": "Impossible de vérifier le code. Veuillez réessayer."
  },
  "errors": {
    "generic": "Impossible de démarrer le paiement. Réessayez."
  },
  "totalUnavailable": "Catalogue de prix indisponible. Réessayez pour charger les derniers prix."
}
